import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Container } from '@mui/material';
import AppAppBar from '../../components/layout/AppAppBar';
import coinStackingGif from '../../assets/coin-stacking_20260102111635.gif';

export default function PaymentProcessingPageFb() {

    useEffect(() => {
        // Simulate processing time then redirect
        const timer = setTimeout(() => {
            window.location.href = '/payment-success';
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
            <Helmet>
                {/* Meta Pixel Code */}
                <script>
                    {`
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '4122405331304618');
                    fbq('track', 'PageView');
                    `}
                </script>
                <noscript>
                    {`<img height="1" width="1" style="display:none"
                    src="https://www.facebook.com/tr?id=4122405331304618&ev=PageView&noscript=1"
                    />`}
                </noscript>
                {/* End Meta Pixel Code */}
            </Helmet>
            {/* Common Navbar */}
            <AppAppBar mode="light" toggleColorMode={() => { }} simpleNavbar={true} transparentMode={true} />

            <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: 'calc(100vh - 60px)', bgcolor: '#fff', pt: 11 }}>
                <Typography
                    variant="h4"
                    sx={{
                        mb: 4,
                        fontWeight: 800,
                        fontFamily: 'General-Sans-bold',
                        color: '#000',
                        position: 'relative',
                        display: 'inline-block',
                        zIndex: 1
                    }}
                >
                    Payment Status
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: '6px',
                            right: '-5px',
                            width: '60%',
                            height: '14px',
                            bgcolor: '#FFC107',
                            zIndex: -1,
                            borderRadius: '20px'
                        }}
                    />
                </Typography>

                {/* Coin Stacking GIF */}
                <Box sx={{ width: 250, height: 250, mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                        src={coinStackingGif}
                        alt="Processing payment"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }}
                    />
                </Box>

                <Typography variant="h5" sx={{ color: '#EF6C00', fontWeight: 700, mb: 2 }}>
                    Processing Payment
                </Typography>

                <Typography variant="body2" sx={{ textAlign: 'center', color: '#757575', maxWidth: 300 }}>
                    {
                        "Note: Wait for 24 hours to recieve your payment."
                    }
                </Typography>
            </Container>
        </Box>
    );
}
